import { Pipe, PipeTransform } from '@angular/core';
import { AssetsService } from 'src/services/assets.service';

@Pipe({ name: 'assetUrl' })
export class AssetUrlPipe implements PipeTransform {
  constructor(private assets: AssetsService) {}

  transform(path: string): string {
    return this.assets.getUrl(path);
  }
}
